import { render, staticRenderFns } from "./AxConfirmDialog.vue?vue&type=template&id=1dd2ff54&scoped=true&"
import script from "./AxConfirmDialog.vue?vue&type=script&lang=ts&"
export * from "./AxConfirmDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AxConfirmDialog.vue?vue&type=style&index=0&id=1dd2ff54&prod&lang=scss&scoped=true&"
import style1 from "./AxConfirmDialog.vue?vue&type=style&index=1&id=1dd2ff54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd2ff54",
  null
  
)

export default component.exports